// Kill feed (top right): at most 6 rows, each lives 5 s. Rows are DOM nodes built per event.

import { div, span } from "./dom";
import { weaponLabel } from "./format";
import { causeIcon, icon, tagIcon } from "./icons";
import { KillfeedQueue } from "./killfeedQueue";
import type { KillfeedEntry, TeamTag } from "./types";

const IN_FRAMES: Keyframe[] = [
  { opacity: 0, transform: "translateX(18px)" },
  { opacity: 1, transform: "translateX(0)" },
];
const IN_OPTS: KeyframeAnimationOptions = { duration: 160, easing: "cubic-bezier(0.2, 0.7, 0.2, 1)" };
const FADE_MS = 400;

function nameEl(name: string, team: TeamTag): HTMLSpanElement {
  const n = span(`hud-kf__name hud-team-${team}`);
  n.textContent = name;
  return n;
}

export class Killfeed {
  readonly root = div("hud-killfeed");
  private readonly queue = new KillfeedQueue<HTMLDivElement>();

  /** Add a row (newest at the bottom). `nowMs` is the performance clock. */
  push(e: KillfeedEntry, nowMs: number): void {
    const row = div(e.mine ? "hud-kf is-mine" : "hud-kf");
    if (e.killer !== null) row.append(nameEl(e.killer, e.killerTeam));
    const how = span("hud-kf__how");
    const cause = causeIcon(e.weapon);
    if (cause) how.append(icon(cause, "hud-kf__icon"));
    how.append(span("hud-kf__weapon", weaponLabel(e.weapon)));
    if (e.headshot) how.append(icon("headshot", "hud-kf__icon hud-kf__icon--hs"));
    for (const t of e.tags) {
      const name = tagIcon(t);
      if (name) how.append(icon(name, "hud-kf__icon hud-kf__icon--tag"));
    }
    row.append(how, nameEl(e.victim, e.victimTeam));

    this.root.append(row);
    const evicted = this.queue.push(row, nowMs);
    if (evicted) evicted.remove();
    row.animate(IN_FRAMES, IN_OPTS);
    const life = this.queue.lifetimeMs;
    row.animate([{ opacity: 1 }, { opacity: 1, offset: 1 - FADE_MS / life }, { opacity: 0 }], { duration: life, fill: "forwards" });
  }

  /** Per frame: drop expired rows. No work while nothing is due. */
  update(nowMs: number): void {
    if (nowMs < this.queue.nextExpiry()) return;
    let row: HTMLDivElement | undefined;
    while ((row = this.queue.popExpired(nowMs))) row.remove();
  }
}
